import UCPList from './UCPList';

export default UCPList; 